import React, { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Save, ShieldCheck } from "lucide-react";
import { changePassword } from "@/lib/adminApi";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function AdminSettings() {
  const { admin } = useAdminAuth();
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error("A nova senha precisa ter ao menos 8 caracteres.");
      return;
    }
    if (next !== confirm) {
      toast.error("Confirmação de senha diferente.");
      return;
    }
    setSaving(true);
    try {
      await changePassword(cur, next);
      toast.success("Senha atualizada com sucesso");
      setCur("");
      setNext("");
      setConfirm("");
    } catch (e) {
      const msg = e?.response?.data?.detail || "Erro ao trocar senha";
      toast.error(typeof msg === "string" ? msg : "Erro");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-settings-page">
      <div className="hub-eyebrow">Configurações</div>
      <h1 className="mt-2 font-display font-medium text-3xl sm:text-4xl tracking-tight">
        Conta administrativa
      </h1>
      <p className="mt-2 text-slate-600">
        Atualize sua senha de acesso ao Painel HUB.
      </p>

      <div className="mt-8 grid lg:grid-cols-2 gap-6">
        <div className="hub-card p-6">
          <div className="hub-eyebrow">Sessão atual</div>
          <div className="mt-3 flex items-center gap-2">
            <ShieldCheck size={16} className="text-[#16A34A]" />
            <div className="text-sm text-slate-700">
              Autenticado como <b>{admin?.email}</b>
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="hub-card p-6">
          <div className="hub-eyebrow">Alterar senha</div>
          <div className="mt-4 space-y-3">
            <label className="block">
              <span className="block text-xs uppercase tracking-[0.16em] font-semibold text-slate-500 mb-2">
                Senha atual
              </span>
              <input
                data-testid="settings-current-password"
                type="password"
                required
                className="hub-input"
                value={cur}
                onChange={(e) => setCur(e.target.value)}
              />
            </label>
            <label className="block">
              <span className="block text-xs uppercase tracking-[0.16em] font-semibold text-slate-500 mb-2">
                Nova senha
              </span>
              <input
                data-testid="settings-new-password"
                type="password"
                required
                minLength={8}
                className="hub-input"
                value={next}
                onChange={(e) => setNext(e.target.value)}
              />
              <span className="mt-1 block text-xs text-slate-500">
                Mínimo de 8 caracteres.
              </span>
            </label>
            <label className="block">
              <span className="block text-xs uppercase tracking-[0.16em] font-semibold text-slate-500 mb-2">
                Confirmar nova senha
              </span>
              <input
                data-testid="settings-confirm-password"
                type="password"
                required
                className="hub-input"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
              />
            </label>
          </div>
          <button
            data-testid="settings-save"
            disabled={saving}
            type="submit"
            className="hub-btn-primary mt-6"
          >
            <Save size={14} /> {saving ? "Salvando…" : "Salvar nova senha"}
          </button>
        </form>
      </div>
    </div>
  );
}
